export const DEFAULT_WIDGETS_STYLE = {
	fill: 'fit-box',
	position: 'center',
	textLabel: {
		text: 'Type something',
		font: 'Poppins',
		fontSize: '12',
		fontWeight: 'normal',
		color: '#126cfc',
		backgroundColor: 'transparent',
		hoverFontWeight: 'normal',
		hoverColor: '#126cfc',
		hoverBackgroundColor: 'transparent',
	},
	backgroundSettings: {
		backgroundColor: 'transparent',
		hoverBackgroundColor: 'transparent',
	},
	transformSettings: {
		borderRadiusLeft: '0',
		borderRadiusTop: '0',
		borderRadiusRight: '0',
		borderRadiusBottom: '0',
		radiusTop: '0',
		radiusBottom: '0',
		radiusRight: '0',
		radiusLeft: '0',
		paddingTop: '0',
		paddingBottom: '0',
		paddingRight: '0',
		paddingLeft: '0',
		hoverRadiusTop: '0',
		hoverRadiusBottom: '0',
		hoverRadiusRight: '0',
		hoverRadiusLeft: '0',
		hoverPaddingTop: '0',
		hoverPaddingBottom: '0',
		hoverPaddingRight: '0',
		hoverPaddingLeft: '0',
	},
	dimension: { w: 150, h: 100 },
	coordinate: { x: 0, y: 0 },
};

export const INTERACT_ELEMENT_ACTIONS = {
	openUrl: 'openUrl',
	jumpToTime: 'jumpToTime',
	loadVideo: 'loadVideo',
	videoToPlaylist: 'videoToPlaylist',
	playPause: 'playPause',
	play: 'play',
	pause: 'pause',
	customEvent: 'customEvent',
	fadeOut: 'fadeOut',
};

export const WIDGET_ACTIONS = {
	clickActions: {
		type: 'onClick',
		goToScene: 'goToScene',
		goToUrl: 'goToUrl',
		jumpToTime: 'jumpToTime',
	},
	entryActions: {
		type: 'onEntry',
		pause: 'pause',
		jumpToTime: 'jumpToTime',
	},
	exitActions: {
		type: 'onExit',
		pause: 'pause',
		jumpToTime: 'jumpToTime',
	},
};

export const getStyle = (checkObject, style, result) => {
	Object.keys(checkObject).forEach((key) => {
		if (checkObject[key] === undefined) {
			return result;
		}

		if (typeof checkObject[key] === 'string' || typeof checkObject[key] === 'number') {
			result[key] = style[key] ?? checkObject[key];
		} else {
			result[key] = style[key] !== undefined ? getStyle(checkObject[key], style[key], {}) : checkObject[key];
		}
	});
	return result;
};
